import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTooltipModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ContactMainReasonsComponent } from './contact-main-reasons.component';

@NgModule({
	declarations: [ContactMainReasonsComponent],
	imports: [CommonModule, TranslateModule.forChild(), FreudTooltipModule],
	exports: [ContactMainReasonsComponent],
	providers: [],
})
export class ContactMainReasonsModule {}
